const RouteNames = {
  MAIN: '/',

  VPS_FREE: 'vps-free',
  VPS_PAID: 'vps-paid',
  VPS_PAID_REDIRECT: 'paid-vps-servers',
  VPS_MANUAL: 'vps-manual',
  VPS_MANUAL_REDIRECT: 'instructions',
  GUIDE: 'guide',
  GUIDE_REDIRECT: 'vps-directory',
  VIDEO: 'video',
  VIDEO_REDIRECT: 'vps-video-tutorials',

  MONITORING: 'monitoring',
  MONITORING_DETAILS: ':monitoringId',
  MONITORING_MANUAL: 'monitoring-manual',

  REBATE: 'rebate',
  REBATE_REDIRECT: 'rebate-service',
  REBATE_BROKERS: 'rebate-brokers',

  PARTNER_CLASSIC: 'classic',
  PARTNER_CLASSIC_REDIRECT: 'partner-program/affiliate-program-for-everyone',
  PARTNER_MULTILEVEL: 'multilevel',
  WHITE_LABEL: 'white-label',
  WHITE_LABEL_REDIRECT: 'partner-program/robot-sellers',
  RESALE: 'resale',
  RESALE_REDIRECT: 'for-brokers',

  RATING: 'brokers',
  BROKER: ':brokerId',

  COURSES: 'courses',
  COURSE: ':courseId',
  COURSES_REDIRECT: 'all-forex',

  ROBOT: 'robot',
  ROBOT_REDIRECT: 'advisor-to-order',

  GLOSSARY: 'glossary',
  GLOSSARY_REDIRECT: 'forex-glossary',

  ARTICLE: ':articleId',

  ABOUT_US: 'about-us',

  PUBLIC_OFFER: 'public-offer',
  PRIVACY_POLICY: 'privacy-policy',
  TERMS_OF_SERVICE: 'terms-of-service',

  ANY: '*',
};

export default RouteNames;
